export default __webpack_public_path__ + "static/media/DGX-H100.65e27691.png";